import { render, staticRenderFns, recyclableRender, components } from "./set-up.vue?vue&type=template&id=a5f981f4&scoped=true&"
var renderjs
import script from "./set-up.vue?vue&type=script&lang=js&"
export * from "./set-up.vue?vue&type=script&lang=js&"
import style0 from "./set-up.vue?vue&type=style&index=0&id=a5f981f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f981f4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/set-up/set-up.vue"
export default component.exports